<nav class="
    fixed
    w-full
    top-0
    border-gray-200
    ">
    <div class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">

        <div class="flex items-center space-x-3 rtl:space-x-reverse"></div>

        <div class="flex items-center md:order-2 space-x-1 md:space-x-0 rtl:space-x-reverse">

            <a href="#" data-tooltip-target="tooltip-discord-01" class="
                    hidden sm:inline-flex items-center justify-center
                    w-10 h-10 text-white hover:bg-gray-700 focus:outline-none
                    focus:ring-4 focus:ring-gray-700 rounded-lg text-sm p-2.5 mr-1
                    ">
                <svg class="
                    w-6 h-6
                    text-white opacity-40
                    " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 21 16">
                    <path
                        d="M16.942 1.556a16.3 16.3 0 0 0-4.126-1.3 12.04 12.04 0 0 0-.529 1.1 15.175 15.175 0 0 0-4.573 0 11.585 11.585 0 0 0-.535-1.1 16.274 16.274 0 0 0-4.129 1.3A17.392 17.392 0 0 0 .182 13.218a15.785 15.785 0 0 0 4.963 2.521c.41-.564.773-1.16 1.084-1.785a10.63 10.63 0 0 1-1.706-.83c.143-.106.283-.217.418-.33a11.664 11.664 0 0 0 10.118 0c.137.113.277.224.418.33-.544.328-1.116.606-1.71.832a12.52 12.52 0 0 0 1.084 1.785 16.46 16.46 0 0 0 5.064-2.595 17.286 17.286 0 0 0-2.973-11.59ZM6.678 10.813a1.941 1.941 0 0 1-1.8-2.045 1.93 1.93 0 0 1 1.8-2.047 1.919 1.919 0 0 1 1.8 2.047 1.93 1.93 0 0 1-1.8 2.045Zm6.644 0a1.94 1.94 0 0 1-1.8-2.045 1.93 1.93 0 0 1 1.8-2.047 1.918 1.918 0 0 1 1.8 2.047 1.93 1.93 0 0 1-1.8 2.045Z">
                    </path>
                </svg>
            </a>

            <div id="tooltip-discord-01" role="tooltip"
                class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white rounded-lg shadow-sm opacity-0 tooltip bg-gray-700">

                {{ translate('soon...') }}

                <div class="tooltip-arrow" data-popper-arrow></div>
            </div>


            <a href="#" data-tooltip-target="tooltip-telegram-01" class="
                    hidden sm:inline-flex items-center justify-center
                    w-10 h-10 text-white hover:bg-gray-700 focus:outline-none
                    focus:ring-4 focus:ring-gray-700 rounded-lg text-sm p-2.5 mr-1
                    ">

                <img src="https://jovdev-ws-02-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/generic-ui/sprites/telegram-logo-fill-svgrepo-com.svg"
                    class="w-6 h-6 text-white opacity-40" alt="">
            </a>

            <div id="tooltip-telegram-01" role="tooltip"
                class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white rounded-lg shadow-sm opacity-0 tooltip bg-gray-700">

                {{ translate('soon...') }}

                <div class="tooltip-arrow" data-popper-arrow></div>
            </div>


            <a href="https://x.com/0xBASE-ANGULAR-PROJECT-01" target="_blank" data-tooltip-target="tooltip-twitter-01" class="
                    hidden sm:inline-flex items-center justify-center
                    w-10 h-10 text-white hover:bg-gray-700 focus:outline-none
                    focus:ring-4 focus:ring-gray-700 rounded-lg text-sm p-2.5 mr-1
                    ">
                <svg class="w-4.5 h-4.5 text-white opacity-40" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="none" viewBox="0 0 24 24">
                    <path fill="currentColor"
                        d="M13.8 10.5 20.7 2h-3l-5.3 6.5L7.7 2H1l7.8 11-7.3 9h3l5.7-7 5.1 7H22l-8.2-11.5Zm-2.4 3-1.4-2-5.6-7.9h2.3l4.5 6.3 1.4 2 6 8.5h-2.3l-4.9-7Z">
                    </path>
                </svg>
            </a>

            <div id="tooltip-twitter-01" role="tooltip"
                class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white rounded-lg shadow-sm opacity-0 tooltip bg-gray-700">

                {{ translate('Follow it on Twitter!') }}

                <div class="tooltip-arrow" data-popper-arrow></div>
            </div>



            <button *ngIf="!_isSelectingLanguage" (click)="OpenLanguageSelectionButton()" type="button"
                class="
                    bg-red-500/0
                    w-32 h-10
                    inline-flex items-center font-medium justify-center px-4 py-2 text-xs text-white rounded-lg cursor-pointer hover:bg-gray-700 hover:text-white">

                <div class="
                    flex flex-col
                    items-center
                    w-3.5 h-3.5 me-3
                    rounded-full bg-cover overflow-hidden
                    ">
                    <img src="https://jovdev-ws-02-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/home/{{ currentLanguage.flagIconName }}.svg"
                        class="h-full max-w-none" alt="">
                </div>

                {{ currentLanguage.name }}

            </button>

            <div *ngIf="_isSelectingLanguage" class="
                bg-green-500/0
                w-32 h-10
                ">

                <div class="
                    absolute
                    w-32
                    text-base list-none divide-y divide-gray-100 rounded-lg shadow bg-gray-700">

                    <div class="">

                        <ul class="py-2 font-medium" role="none">


                            <li *ngFor="let languageOption of languageOptions">
                                <a (click)="LanguageOptionButton(languageOption.id)"
                                    class="block px-4 py-2 text-sm text-gray-400 hover:bg-gray-600 hover:text-white"
                                    role="menuitem">
                                    <div class="inline-flex items-center text-xs">

                                        <div class="
                                            flex flex-col
                                            items-center
                                            h-3.5 w-3.5 me-2
                                            rounded-full bg-cover overflow-hidden
                                            ">

                                            <img src="https://jovdev-ws-02-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/home/{{ languageOption.flagIconName }}.svg"
                                                class="h-full max-w-none" alt="">

                                        </div>

                                        <span class="
                                            font-bold
                                            {{ currentLanguage.name == languageOption.name ? 'text-white underline' : '' }}
                                            ">
                                            {{ languageOption.name }}
                                        </span>


                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </div>
</nav>
